// Portions of this code are adapted from the MUI Toolbar component.
// Source: https://github.com/mui/toolpad/blob/master/packages/toolpad-core/src/DashboardLayout/utils.ts
// MUI is licensed under the MIT License: https://github.com/mui/toolpad/blob/master/LICENSE

import type { Theme } from '@mui/material';

export function getDrawerSxTransitionMixin(isExpanded: boolean, property: string) {
    return {
        transition: (theme: Theme) =>
            theme.transitions.create(property, {
                easing: theme.transitions.easing.sharp,
                duration: isExpanded
                    ? theme.transitions.duration.enteringScreen
                    : theme.transitions.duration.leavingScreen,
            }),
    };
}

export function getDrawerWidthTransitionMixin(isExpanded: boolean) {
    return {
        ...getDrawerSxTransitionMixin(isExpanded, 'width'),
        overflowX: 'hidden',
    };
}
